module.exports = __webpack_public_path__ + "wordmark.1ac2a390.svg";